import { BaseEntity } from "yt-ng-framework";

export class CompanyTelefon extends BaseEntity{
    constructor(){
        super();
    }

    FirmaID: number = null;
    Glavni:boolean = null;
    VrstaTelefonaID:number = null;
    Broj:string = null;
    Lokal:string = null;
    SvojinaID:number = null;
    // Opis:string = null;
    Opis:string = "";

    Deserialize(input:any){
        this.ID=input.ID;
        this.FirmaID=input.FirmaID;
        this.Glavni=input.Glavni;
        this.VrstaTelefonaID=input.VrstaTelefonaID;
        this.Broj=input.Broj;
        this.Lokal=input.Lokal;
        this.SvojinaID=input.SvojinaID;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:CompanyTelefon){
        return input;
    }
}